import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSocialListening = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3333 14.1667V10.8333C18.3333 6.23096 14.6023 2.5 9.99996 2.5C5.39759 2.5 1.66663 6.23096 1.66663 10.8333V14.1667M6.24996 17.5C5.09937 17.5 4.16663 16.5673 4.16663 15.4167V12.9167C4.16663 11.7661 5.09937 10.8333 6.24996 10.8333C7.40055 10.8333 8.33329 11.7661 8.33329 12.9167V15.4167C8.33329 16.5673 7.40055 17.5 6.24996 17.5ZM13.75 17.5C12.5994 17.5 11.6666 16.5673 11.6666 15.4167V12.9167C11.6666 11.7661 12.5994 10.8333 13.75 10.8333C14.9006 10.8333 15.8333 11.7661 15.8333 12.9167V15.4167C15.8333 16.5673 14.9006 17.5 13.75 17.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSocialListening;
